// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import xvksign from './xvksign'
import FontFaceObserver from 'fontfaceobserver';
import axios from "axios"
import connect from '@vkontakte/vkui-connect-promise';
import fonts from './fonts.json'

Vue.config.productionTip = false

if (location.pathname.indexOf("mobile") != -1 || window.innerWidth < 659) {
  window._isMobile = true;
}

if ('clientInformation' in window && /iphone/i.test(window.clientInformation.userAgent)) {
  window._isIphone = true;
} else if ('clientInformation' in window && /android/i.test(window.clientInformation.userAgent)) {
  window._isAndroid = true
}

window.host = '';

if (process.env.NODE_ENV != 'production') {
  window.host = 'http://localhost:38005'
}

window.qs = {}

location.search.substr(1).split('&').forEach(o => {
  const _o = o.split('=')

  qs[_o[0]] = _o[1]
})

axios.defaults.headers.common['X-VK-Params'] = window.xvk

const init = async () => {
  if (process.env.NODE_ENV == 'production' && !qs.vk_group_id) {
    // return
  }

  const prmFonts = [];

  try {
    fonts.forEach(font => {
      prmFonts.push(new FontFaceObserver(font).load())

      console.log('push', font)
    });
    await Promise.all(prmFonts);
  } catch (err) {
    console.error('Error -> FontFaceObserver')
    console.error(err)
  }

  const {
    data: {
      sex
    }
  } = await connect.send("VKWebAppGetUserInfo", {})


  new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App/>',
    data() {
      return {
        user: {
          sex
        },
        info: {
          canVote: true,
          state: 0
        },
        options: [
          /*
          {
            id: 1,
            title: 'Вариант 1',
            descr: 'Описание текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст',
            img: 1,
            color: ['0102F8', 'FFFFFF', '0102F8', 'FFFFFF', 'FDB1FE'],
            votes: 0,
            img: 7176
          }, {
            id: 2,
            title: 'Вариант 2',
            descr: 'Описание текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст',
            img: 2,
            color: ['FDB1FF', '000000', '0102F8', 'FFFFFF', '0102F8'],
            votes: 0,
            img: 7176
          }, {
            id: 3,
            title: 'Вариант 3',
            descr: 'Описание текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст',
            img: 3,
            color: ['FFE201', '000000', '0102F8', 'FFFFFF', 'F90048'],
            votes: 0,
            img: 7176
          }, {
            id: 4,
            title: 'Вариант 4',
            descr: 'Описание текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст текст',
            img: 4,
            color: ['92E8FF', '000000', '0102F8', 'FFFFFF', '0102F8'],
            votes: 0,
            img: 7176
          }, //*/
        ]
      }
    },
    async created() {
      this.vkAppsInit()

      const {
        data: {
          response
        }
      } = await axios.get(`${window.host}/api/get`, {
        params: {}
      })

      this.info.canVote = false // response.info.canVote
      this.info.state = 1 // response.info.canVote ? 0 : 1
      this.info.my = response.info.my

      this.processOptions(response.options, this.info.my)
    },
    methods: {
      vkAppsInit() {
        connect.send('VKWebAppInit', {})
          .then(console.log)
          .catch(console.error)
      },
      processOptions(options, _id) {
        let totalVotes = 0,
          percents = []

        options.forEach(o => {
          totalVotes += o.votes
        })

        // console.log('Total:', totalVotes)

        options.forEach((o, index) => {
          // console.log(`Option ${o.id}:`, o.votes)

          if (index == options.lenght - 1) {
            let prcnts = 0

            percents.forEach(p => (prcnts += p))

            o.percent = (100 - prcnts).toFixed(0)
          } else {
            o.percent = ((o.votes / totalVotes).toFixed('2') * 100).toFixed(0)

            percents.push(o.percent)
          }
        })

        this.options = []

        options.forEach(o => {
          // console.log('options.forEach', o.id == _id, o.id, _id)

          if (o.id == _id) {
            --o.votes
          }

          let votes = o.votes

          if (o.votes > 999 && o.votes < 1000000) {
            votes = `${(o.votes / 1000).toFixed(1)}K`
          } else if (o.votes > 999999) {
            votes = `${(o.votes / 1000000).toFixed(1)}M`
          }

          votes = votes.toString().replace('.', ',')

          this.options.push({
            id: o.id,
            title: o.title,
            descr: o.descr,
            img: o.img,
            color: o.color.split(' '),
            votes,
            percent: o.percent
          })
        })
      }
    }
  })
}

init()



// WEBPACK FOOTER //
// ./src/main.js